<!-- Footer -->
<footer
  class="text-center text-lg-start text-white"
  style="background-color: #222429"
>
  <!-- Section: Social media -->
  <section
    class="d-flex justify-content-between p-4"
    style="background-color: #343a40"
  >
    <div class="me-5">
      <span style="font-weight: 500;">Seguinos en nuestras redes:</span>
    </div>
    <div>
      <a
        href="https://www.facebook.com/share/v16zoeDYbHt4Fu6M/?mibextid=qi2Omg"
        class="text-white me-4"
      >
        <i class="fab fa-facebook-f fa-lg"></i>
      </a>
      <a
        href="https://www.instagram.com/lightcapgroup?utm_source=qr&igsh=dnFoYjV1Z29waDA0"
        class="text-white me-4"
      >
        <i class="fab fa-instagram fa-lg"></i>
      </a>
      <a
        href="https://www.linkedin.com/company/lightcap-group/"
        class="text-white me-4"
      >
        <i class="fab fa-linkedin fa-lg"></i>
      </a>
      <a href="https://www.youtube.com/@LightCapGroup" class="text-white me-4">
        <i class="fab fa-youtube fa-lg"></i>
      </a>
      <a
        href="https://open.spotify.com/show/3dB7qiTqlJZuTJWXpB0uvb?si=3884ff23181f4838"
        class="text-white me-4"
      >
        <i class="fab fa-spotify fa-lg"></i>
      </a>
    </div>
  </section>

  <!-- Section: Links -->
  <section>
    <div class="container text-md-start px-4 mt-5">
      <div class="row mt-3 align-items-start justify-content-center">
        <!-- Logo column -->
        <div class="col-md-3 col-lg-4 col-xl-3 mb-4 text-center text-md-start">
          <h6 class="text-uppercase fw-bold text-white">LightCap Group</h6>
          <hr
            class="mb-4 mt-0 d-inline-block"
            style="width: 60px; background-color: #fbd541; height: 2px"
          />
          <a href="index.html" class="d-block">
            <img
              src="assets/img/logos/main_logo.svg"
              alt="LightCap|Group"
              class="img-fluid mx-auto d-block"
              style="max-height: 50px"
            />
          </a>
        </div>

        <!-- Contacto column -->
        <div class="col-md-4 col-lg-3 col-xl-3 mb-4 text-md-start">
          <h6 class="text-uppercase fw-bold text-white text-center">
            Contacto
          </h6>
          <hr
            class="mb-4 mt-0 d-inline-block mx-auto"
            style="width: 60px; background-color: #fbd541; height: 2px"
          />
          <p class="d-flex align-items-center text-white-50 mb-2">
            <i class="fas fa-home me-2 text-white"></i> Buenos Aires, Argentina
          </p>
          <p class="d-flex align-items-center text-white-50 mb-2">
            <fa-icon [icon]="faEnvelope" class="me-2 text-white"></fa-icon>
            <a
              href="mailto:contacto@lightcapgroup.com.ar"
              class="text-white-50"
            >
              contacto&#64;lightcapgroup.com.ar
            </a>
          </p>
          <p class="d-flex align-items-center text-white-50 mb-0">
            <a
              href="https://wa.me/5491127759760"
              class="d-flex align-items-center text-white-50 text-decoration-none"
              target="_blank"
              aria-label="WhatsApp"
            >
              <fa-icon [icon]="faPhone" class="text-white"></fa-icon>
              <span class="text-white mx-1">/</span>
              <fa-icon [icon]="faWhatsapp" class="text-white me-2"></fa-icon>
              +54 (911) 2775-9760
            </a>
          </p>
        </div>
      </div>
    </div>
  </section>
</footer>
